// extracted by mini-css-extract-plugin
export default {"text":"TgupDLPgQXNw8EV_jbLg","checkbox":"ITirZBJI1dFmCDV2KbIA","theme":"RWjsHoEKQmzksguHO6EK"};